import React, { useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaCheckCircle, FaAward, FaHeart, FaCertificate } from 'react-icons/fa';

const BeforeAfterGallery = ({ t }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      const elements = sectionRef.current.querySelectorAll('.fade-in, .scroll-fade-up, .scroll-zoom, .stagger-animation > *');
      elements.forEach(el => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="guarantee" className="section-padding before-after-section" ref={sectionRef}>
      <Container>
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <h2 className="section-title scroll-fade-up title-enhance">
              Your Success is Our Guarantee
            </h2>
            <p className="section-subtitle scroll-fade-up fade-in-delay-1">
              We are committed to your complete recovery and well-being with proven results and personalized care.
            </p>
          </Col>
        </Row>

        {/* Success Guarantee Features */}
        <Row className="stagger-animation">
          <Col lg={3} md={6} className="mb-4">
            <div className="guarantee-card text-center scroll-fade-up" style={{'--i': 0}}>
              <div className="guarantee-icon animate-bounce-in">
                <FaCheckCircle className="text-success" />
              </div>
              <h4 className="guarantee-title">95% Success Rate</h4>
              <p className="guarantee-description">
                Proven track record with over 1200+ patients achieving their recovery goals through our evidence-based treatments.
              </p>
            </div>
          </Col>

          <Col lg={3} md={6} className="mb-4">
            <div className="guarantee-card text-center scroll-fade-up" style={{'--i': 1}}>
              <div className="guarantee-icon animate-zoom-in">
                <FaAward className="text-primary" />
              </div>
              <h4 className="guarantee-title">Certified Excellence</h4>
              <p className="guarantee-description">
                BPT qualified physiotherapist with 4+ years of hospital experience in specialized rehabilitation and recovery.
              </p>
            </div>
          </Col>

          <Col lg={3} md={6} className="mb-4">
            <div className="guarantee-card text-center scroll-fade-up" style={{'--i': 2}}>
              <div className="guarantee-icon animate-rotate-in">
                <FaHeart className="text-danger" />
              </div>
              <h4 className="guarantee-title">Patient-Centered Care</h4>
              <p className="guarantee-description">
                Personalized treatment plans designed specifically for your condition, lifestyle, and recovery goals.
              </p>
            </div>
          </Col>

          <Col lg={3} md={6} className="mb-4">
            <div className="guarantee-card text-center scroll-fade-up" style={{'--i': 3}}>
              <div className="guarantee-icon animate-flip-in">
                <FaCertificate className="text-warning" />
              </div>
              <h4 className="guarantee-title">Satisfaction Promise</h4>
              <p className="guarantee-description">
                If you don't see improvement within the first month, we'll extend your treatment plan at no additional cost.
              </p>
            </div>
          </Col>
        </Row>

        {/* Success Metrics */}
        <Row className="mt-5">
          <Col lg={12}>
            <div className="success-metrics-section scroll-zoom bg-white p-5 rounded-3 shadow">
              <Row className="text-center">
                <Col md={3} className="mb-3">
                  <div className="metric-item animate-bounce-in" style={{'--i': 0}}>
                    <span className="metric-number animate-heartbeat">1200+</span>
                    <span className="metric-label">Patients Treated</span>
                  </div>
                </Col>
                <Col md={3} className="mb-3">
                  <div className="metric-item animate-zoom-in" style={{'--i': 1}}>
                    <span className="metric-number animate-pulse">95%</span>
                    <span className="metric-label">Success Rate</span>
                  </div>
                </Col>
                <Col md={3} className="mb-3">
                  <div className="metric-item animate-rotate-in" style={{'--i': 2}}>
                    <span className="metric-number animate-wobble">4+</span>
                    <span className="metric-label">Years Experience</span>
                  </div>
                </Col>
                <Col md={3} className="mb-3">
                  <div className="metric-item animate-flip-in" style={{'--i': 3}}>
                    <span className="metric-number animate-shimmer">10+</span>
                    <span className="metric-label">Specializations</span>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>

        {/* Trust Statement */}
        <Row className="mt-5">
          <Col lg={12} className="text-center">
            <div className="trust-statement scroll-fade-up bg-gradient-primary text-white p-4 rounded-3 animate-glow">
              <h3 className="mb-3 animate-heartbeat">💚 Your Recovery, Our Commitment</h3>
              <p className="mb-0 lead">
                Every patient's journey is unique, and we're dedicated to supporting you every step of the way. 
                From the first consultation to your complete recovery, your success is our success.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BeforeAfterGallery;